export class PrintUtils {
  static print (optoins = {}) {
    let printHtml = this.getPrintHtml(optoins)
    let iframe = document.getElementById('printIframe')
    if (iframe) {
      document.body.removeChild(iframe)
    }
    iframe = document.createElement('iframe')
    iframe.setAttribute('id', 'printIframe')
    document.body.appendChild(iframe)
    iframe.src = 'data:text/html;charset=utf-8, ' + encodeURIComponent(printHtml)
  }

  static getPrintHtml (options = {}) {
    let html = options.html || ''
    let title = options.title || ''
    let css = options.css || ''
    let size = options.size || 'A4'
    let orientation = options.orientation || 'portrait'
    let pageStyle = typeof options.pageStyle === 'boolean' ? options.pageStyle : true
    return `
        <html>
          <head>
            <style>
              ${pageStyle ? this.getPageStyle() : ''}
              ${this.getPrintStyle()}
              @page { 
                size: ${orientation};
              }
              body { background: none; }
              ${css}
              .page-break-before {
                page-break-before: always !important;
              }
              .page-break,
              .page-break-after {
                page-break-after: always !important;
              }
              html, body {
                overflow: visible !important;
              }
            </style>
            <title>${title}</title>
          </head>
          <body class="${size} ${orientation}" onload="window.print()">${html}</body>
        </html>`
  }

  static getPageStyle () {
    var cssRules = []
    for (let i = 0; i < document.styleSheets.length; i++) {
      let sheet = document.styleSheets[i]
      let rules = ('cssRules' in sheet) ? sheet.cssRules : sheet.rules
      for (var j = 0; j < rules.length; j++) {
        let rule = rules[j]
        let cssText = null
        if ('cssText' in rule) {
          cssText = rule.cssText
        } else {
          cssText = rule.selectorText + ' {' + rule.style.cssText + '\n}\n'
        }

        if (cssText.indexOf('@media') >= 0) continue
        let printIndex = cssText.indexOf('print')
        if (printIndex >= 0 && print < cssText.indexOf('{')) {
          continue
        }

        if (cssText) {
          cssRules.push(cssText)
        }
      }
    }
    return cssRules.join('\n')
  }

  static getPrintStyle () {
    return `
      @page {
        margin: 25mm 20mm;
      }
      body { margin: 0 }
      .sheet {
        margin: 0;
        position: relative;
        box-sizing: border-box;
        page-break-after: always !important;
      }
      .spacer-10mm { height: 10mm; }
      .spacer-15mm { height: 15mm; }
      .spacer-20mm { height: 20mm; }
      .spacer-25mm { height: 25mm; }

      /** Paper sizes **/
      body.A3               .sheet { width: 297mm; height: 419mm }
      body.A3.landscape     .sheet { width: 420mm; height: 296mm }
      body.A4               .sheet { width: 210mm; height: 296mm }
      body.A4.landscape     .sheet { width: 297mm; height: 209mm }
      body.A5               .sheet { width: 148mm; height: 209mm }
      body.A5.landscape     .sheet { width: 210mm; height: 147mm }
      body.letter           .sheet { width: 216mm; height: 279mm }
      body.letter.landscape .sheet { width: 280mm; height: 215mm }
      body.legal            .sheet { width: 216mm; height: 356mm }
      body.legal.landscape  .sheet { width: 357mm; height: 215mm }
      .print.A3                 { width: 297mm; height: 419mm }
      .print.A3.landscape       { width: 420mm; height: 296mm }
      .print.A4                 { width: 210mm; height: 296mm }
      .print.A4.landscape       { width: 297mm; height: 209mm }
      .print.A5                 { width: 148mm; height: 209mm }
      .print.A5.landscape       { width: 210mm; height: 147mm }
      .print.letter             { width: 216mm; height: 279mm }
      .print.letter.landscape   { width: 280mm; height: 215mm }
      .print.legal              { width: 216mm; height: 356mm }
      .print.legal.landscape    { width: 357mm; height: 215mm }

      /** Padding area **/
      .padding-10mm { padding: 10mm }
      .padding-15mm { padding: 15mm }
      .padding-20mm { padding: 20mm }
      .padding-25mm { padding: 25mm }

      /** For screen preview **/
      @media screen {
        body { background: #e0e0e0 }
        .sheet {
          background: white;
          box-shadow: 0 .5mm 2mm rgba(0,0,0,.3);
          margin: 5mm auto;
        }
      }

      /** Fix for Chrome issue #273306 **/
      @media print {
        body.A3.landscape          { width: 420mm }
        body.A3, body.A4.landscape { width: 297mm }
        body.A4, body.A5.landscape { width: 210mm }
        body.A5                    { width: 148mm }
        body.letter, body.legal    { width: 216mm }
        body.letter.landscape      { width: 280mm }
        body.legal.landscape       { width: 357mm }
      }`
  }
}
